/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

const CustomerInformation = ({
    booking: {
        passengerName,
        passengerPronounced,
        customer,
        passengerPhoneNumber,
        passengerPrefixNumber,
    } = {}
}) => {
    return (
        <>
            <h5 className={`tw:!font-hanken-grotesk tw:!mb-4 tw:!text-[15px] tw:!font-[600] tw:!text-[#282828]`}>
                <span className="tw:relative tw:inline-block">
                    <span className="tw:absolute tw:bottom-0 tw:left-0 tw:right-0 tw:h-[40%] tw:rounded-full tw:bg-[#F9EDD3]" />
                    <span className="tw:relative">Customer Information</span>
                </span>
            </h5>
            <div className="border rounded mb-5">
                <div className="d-flex align-items-start gap-5 p-3">
                    <div className="flex-shrink-0" style={{ width: '120px' }}>
                        <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[700] tw:!text-[#4E4E4E]">
                            {`Passenger\nInformation`}
                        </b>
                    </div>
                    <div className="d-flex flex-wrap" style={{ flex: 1, columnGap: '3rem', rowGap: '0.75rem' }}>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Passenger's Name</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{passengerPronounced || ""} {passengerName || "-"}</b>
                        </div>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Passenger's Phone No.</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                {
                                    passengerPrefixNumber && passengerPhoneNumber ? `(${passengerPrefixNumber}) ${passengerPhoneNumber}` : "-"
                                }
                            </b>
                        </div>
                    </div>
                </div>
                <hr className="hr-E8E8E8 m-0" />
                <div className="d-flex align-items-start gap-5 p-3">
                    <div className="flex-shrink-0" style={{ width: '120px' }}>
                        <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[700] tw:!text-[#4E4E4E]">
                            {`Billing\nInformation`}
                        </b>
                    </div>
                    <div className="d-flex flex-wrap" style={{ flex: 1, columnGap: '3rem', rowGap: '0.75rem' }}>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Reservation Holder</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{customer?.pronounced || ""} {customer?.name || "-"}</b>
                        </div>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Email</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{customer?.email || "-"}</b>
                        </div>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Phone No.</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">
                                {
                                    customer?.prefix_number && customer?.phone ? `(${customer?.prefix_number}) ${customer?.phone}` : "-"
                                }
                            </b>
                        </div>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Country</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{customer?.country || "-"}</b>
                        </div>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Postal Code</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{customer?.postal_code || "-"}</b>
                        </div>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">City</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{customer?.city || "-"}</b>
                        </div>
                        <div>
                            <p className="tw:!font-hanken-grotesk tw:!m-0 tw:!text-[13px] tw:!font-[400] tw:!text-[#8D8D8D]">Billing Address</p>
                            <b className="tw:!font-hanken-grotesk tw:!text-[15px] tw:!font-[400] tw:!text-[#282828]">{customer?.address || "-"}</b>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomerInformation;
